/* eslint-disable react/no-danger */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';
import Link from '@nubank/nuds-web/components/Link/Link';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

import { useDynamicYieldValues } from '../../../../utils/dynamicYield';

const StyledDescription = styled(Typography)`
  strong { 
    font-weight: bold;
  }
`;

const StyledImage = styled(Image)` 
  @media (width >= 1151px) {
    max-height: 350px;
  }
`;

function DesktopFeatureCard({
  imageDesktop,
  alt,
  title,
  description,
  link,
  id,
}) {
  const { formatMessage } = useIntl();
  const { values: dynamicYieldValues } = useDynamicYieldValues();
  return (
    <Box
      id={`card-${id}`}
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      height="100%"
    >
      {/* CONTENT BOX */}

      <Box
        backgroundColor="#F8F8FA"
        padding={{ xs: '8x', lg: '8x' }}
        borderRadius={{ md: '12px 12px 0px 0px', lg: '12px 0px 0px 12px' }}
        minHeight={{ xs: '320px', md: '50%' }}
        width={{ xs: '100%', lg: '50%' }}
        display="flex"
        justifyContent="center"
      >

        <Box
          alignSelf="center"
          paddingHorizontal={{ xs: '0', lg: '16x' }}
        >
          <Typography
            variant="heading4"
            marginBottom="8x"
            maxWidth="345px"
          >
            {title}
          </Typography>

          <StyledDescription
            variant="subtitle1"
            marginBottom="8x"
            maxWidth="345px"
            whiteSpace="pre-line"
            dangerouslySetInnerHTML={{ __html: formatMessage({ id: `carouselItem.${id}`, defaultMessage: description }, dynamicYieldValues) }}
          />

          <Link
            variant="action"
            href={link}
          >
            Descubre más
          </Link>
        </Box>

      </Box>

      {/* IMAGE BOX */}
      <Box
        background="linear-gradient(151deg, #9F2DEB 1.22%, #6200A3 64.1%), #7B4DD6"
        width={{ xs: '100%', lg: '50%' }}
        display="flex"
        justifyContent="center"
        borderRadius={{ md: '0px 0px 12px 12px', lg: '0px 12px 12px 0px' }}
        alignItems="end"
        paddingHorizontal={{ xs: '8x', lg: '0' }}
        paddingTop={{ xs: '6x', lg: '0' }}
      >
        <StyledImage
          src={imageDesktop}
          alt={alt}
        />
      </Box>

    </Box>

  );
}

DesktopFeatureCard.propTypes = {
  alt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  imageDesktop: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default DesktopFeatureCard;
